import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import "./OwnerPortal.css";

function AdminPortal({ onClose }) {
  const { getAdminStatus, user } = useAuth();
  const [status, setStatus] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    getAdminStatus()
      .then((result) => {
        if (active) setStatus(result);
      })
      .catch((adminError) => {
        if (active) setError(adminError.message);
      });
    return () => {
      active = false;
    };
  }, [getAdminStatus]);

  return (
    <div className="ownerPortalBackdrop" role="presentation">
      <section className="ownerPortal" role="dialog" aria-modal="true" aria-labelledby="admin-portal-title">
        <header>
          <div>
            <span>ANINATRADE ADMIN ACCESS</span>
            <h2 id="admin-portal-title">Admin Portal</h2>
            <p>Operational administration is server-verified, least-privilege, and audit logged.</p>
          </div>
          <button type="button" onClick={onClose} aria-label="Close Admin Portal">×</button>
        </header>

        {error && <div className="ownerPortalError" role="alert">{error}</div>}
        {!error && !status && <div className="ownerPortalLoading">Verifying admin permissions…</div>}
        {status?.authorized && (
          <div className="ownerPortalGrid">
            <article><span>IDENTITY</span><strong>{user?.email}</strong><small>{user?.id}</small></article>
            <article><span>ROLE</span><strong>{user?.role === "owner" ? "Owner" : "Admin"}</strong><small>Server-verified app metadata</small></article>
            <article><span>AUDIT</span><strong>Recorded</strong><small>This privileged access event was written server-side.</small></article>
            <article><span>BOUNDARY</span><strong>Least privilege</strong><small>Admin access does not grant owner-only capabilities or user-private data access.</small></article>
          </div>
        )}
      </section>
    </div>
  );
}

export default AdminPortal;
